/* src/app/views/area-publica/home-page/mapa-brasil/regiao-sul/regiao-sul.component.scss */
.label-projetos {
  font-family: "Alegreya Sans Regular";
}
.contador-projetos {
  font-family: "Alegreya Sans ExtraBold";
}
.nome-estado {
  font-family: "Alegreya Sans ExtraBold";
}
.estado {
  cursor: pointer;
  fill: transparent;
}
/*# sourceMappingURL=regiao-sul.component.css.map */
